import { type JSX } from 'react/jsx-runtime';
import { createRender, type RenderProps } from './types';
import { JiraSideNavCrossJoinMessage } from '@post-office/message-templates-common--puma/in-app/cjn-nav4/components/JiraSideNavCrossJoinMessage';
import { targetProduct } from '../../../target-product';

export const render: (renderProps: RenderProps) => JSX.Element | null = createRender((props) => (
	<JiraSideNavCrossJoinMessage {...props} targetProduct={targetProduct.productKey} />
));

export default render;
